import { LiveAgentsGate, requireLiveAgentsEnabled } from "~/components/live-agents-gate";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents_/$id")({
  beforeLoad: requireLiveAgentsEnabled,
  component: () => (
    <LiveAgentsGate>
      <Outlet />
    </LiveAgentsGate>
  ),
});
